import { translate } from 'react-translate'
import Total from './total'

export default translate('DataTable')(Total)
